import { dataCameraSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCameraSolid = /*#__PURE__*/createIcon(dataCameraSolid)
export default IconCameraSolid
